export default {
    state: {
      logs: {
        show: false,
        loading: false,
        current: '',
        list: []
      },
      originalData: []
    },
    mutations: {
      setLogsData (state, data) {
        for (let field in data) {
          state.logs[field] = data[field]
        }
      },
      setOriginalData (state, val) {
        state.originalData = val
      },
    }
  }
  


// WEBPACK FOOTER //
// ./src/store/pricing/logs.js